import { headers, baseUrl, extendHeaders } from "./HelpService";


const PageUrl = baseUrl + 'removal_shipment/';

const getRemovalShipments = (accountId) => {
    return fetch(PageUrl + `getRemovalShipments/?account_id=${encodeURIComponent(accountId)}`, {
        method: "GET",
        headers: headers()
    }).then((response) => response.json());
};


const updateOrderDetails = (account_id: number, removal_order_id, order_details) => {
    return fetch(PageUrl + "updateOrderDetails/", {
        method: "PUT",
        headers: extendHeaders(),
        body: JSON.stringify({
            account_id: account_id,
            removal_order_id: removal_order_id, order_details: order_details
        })
    })
        .then((response: any) => response.json())
        .catch((error) => {
            return null;
        });
};


const RemovalShipmentsService = {
    getRemovalShipments,
    updateOrderDetails
};

export default RemovalShipmentsService;
